import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ChangeDetectorRef,
  ViewChild,
  OnInit,
  OnChanges
} from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TrackingPageProductsFeed } from '../../tracking-page.model';
import { NavigationOptions } from 'swiper/types';
import { isEqual } from 'lodash';
import { isDefined } from 'app/helpers';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

if (SwiperCore) {
  SwiperCore.use([Navigation, Autoplay]);
}

@Component({
  selector: 'app-tracking-page-products-feed',
  templateUrl: './tracking-page-products-feed.component.html',
  styleUrls: ['./tracking-page-products-feed.component.scss']
})
export class TrackingPageProductsFeedComponent implements OnInit, OnChanges {
  @Input() productFeed: TrackingPageProductsFeed;
  @Input() productItems;
  @Input() mode: any;
  @Input() feedId: any;
  @Input() selectedId: any;
  @Input() isVisualBuilder = true;
  @Output() selectBlock = new EventEmitter();

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

  public readonly imageUrl = environment.assetsUrl;
  isMobileOrSidebar: boolean;
  destroy: boolean;

  constructor(private changesDetector: ChangeDetectorRef) {}

  get navigationOptions(): NavigationOptions {
    return {
      nextEl: '.' + this.feedId + '.swiper-button-next',
      prevEl: '.' + this.feedId + '.swiper-button-prev'
    };
  }

  ngOnInit() {
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileOrSidebar =
      this.feedId === 'sidebarProductsFeed' ||
      this.mode === 'mobile' ||
      window.matchMedia('(max-width: 767px)').matches;
    if (!this.destroy && !!this.swiper && !!this.swiper.swiperRef) {
      this.reloadSlider();
    }
  }

  arrowsStyles(side = 'left') {
    const { arrowSize, arrowColor } = this.productFeed.sliderOptions || {
      arrowSize: 24,
      arrowColor: '#5780ff'
    };
    return {
      'fontSize.px': (arrowSize || 24) / 2,
      color: arrowColor || '#5780ff',
      border: '1.5px solid #CFD2DB',
      'borderRadius.px': arrowSize || 24,
      'marginTop.px': -0.5 * (arrowSize || 24),
      'width.px': arrowSize || 24,
      'height.px': arrowSize || 24,
      'paddingLeft.rem': side === 'left' ? 0 : 0.1,
      'paddingRight.rem': side === 'left' ? 0.1 : 0
    };
  }

  get swiperConfig() {
    this.isMobileOrSidebar =
      this.feedId === 'sidebarProductsFeed' || this.mode === 'mobile';
    //   || window.matchMedia('(max-width: 767px)').matches;
    return {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      breakpointsBase: 'container',
      centeredSlides: this.isMobileOrSidebar,
      loop: this.productFeed?.sliderOptions?.loop || false,
      breakpoints: {
        200: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true
        },
        350: {
          slidesPerView: this.isMobileOrSidebar ? 1 : 2,
          spaceBetween: this.isMobileOrSidebar ? 0 : 10,
          centeredSlides: this.isMobileOrSidebar
        },
        480: {
          slidesPerView: this.isMobileOrSidebar ? 1 : 3,
          spaceBetween: 10,
          centeredSlides: this.isMobileOrSidebar
        },
        767: {
          slidesPerView: this.isMobileOrSidebar ? 1 : 4,
          spaceBetween: 10,
          centeredSlides: this.isMobileOrSidebar
        }
      },
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      autoplay: {
        delay: 300
      }
    };
  }

  selectProductFeed(
    {
      target,
      button,
      buttonText,
      title,
      price,
      titleSpan,
      priceSpan1,
      priceSpan2
    },
    prevBtn,
    nextBtn
  ) {
    const isChild = this.isFeedItemChild(target);
    const placement = this.feedId.replace('ProductsFeed', '');
    if (isChild && isDefined(buttonText)) {
      if (isEqual(target, title) || isEqual(target, titleSpan)) {
        this.selectBlock.emit(`${placement}ProductsFeedCardTitle`);
      } else if (
        isEqual(target, price) ||
        isEqual(target, priceSpan1) ||
        isEqual(target, priceSpan2)
      ) {
        this.selectBlock.emit(`${placement}ProductsFeedCardPrice`);
      } else if (isEqual(target, button) || isEqual(target, buttonText)) {
        this.selectBlock.emit(`${placement}ProductsFeedCardButton`);
      } else {
        this.selectBlock.emit(`${placement}ProductsFeedCard`);
      }
    } else if (!isChild) {
      if (isEqual(target, nextBtn) || isEqual(target, prevBtn)) {
        this.selectBlock.emit(`${placement}ProductsFeedSliderStyle`);
      } else {
        this.selectBlock.emit(this.feedId);
      }
    }
  }

  ngOnChanges(changes) {
    const { productFeed, mode } = changes;
    if (
      (!!productFeed &&
        !!this.swiper &&
        !!this.swiper.swiperRef &&
        (productFeed.currentValue.sliderOptions.autoplayDelay !==
          productFeed.previousValue.sliderOptions.autoplayDelay ||
          productFeed.currentValue.sliderOptions.autoplay !==
            productFeed.previousValue.sliderOptions.autoplay ||
          productFeed.currentValue.sliderOptions.loop !==
            productFeed.previousValue.sliderOptions.loop ||
          productFeed.currentValue.productItems !==
            productFeed.previousValue.productItems)) ||
      (!!mode && !!this.swiper && !!this.swiper.swiperRef)
    ) {
      this.reloadSlider();
    }
  }

  private reloadSlider() {
    setTimeout(() => {
      this.destroy = false;
      this.changesDetector.detectChanges();
    });
    this.destroy = true;
  }

  private isFeedItemChild(target: any): boolean {
    let current = target.parentNode;
    while (
      !!current.localName &&
      current.localName !== 'app-tracking-page-products-feed'
    ) {
      if (current.localName === 'app-tracking-page-products-feed-item') {
        return true;
      }
      current = current.parentNode;
    }
    return false;
  }

  initSwiper() {
    if (this.productFeed.sliderOptions.autoplay) {
      this.swiper.swiperRef.autoplay.start();
    } else {
      this.swiper.swiperRef.autoplay.stop();
    }
  }
}
